import { cn } from "@omni/utils/styles";

type StoreStatusProps = {
    isOpen: boolean;
    statusText?: string;
    openClosesAt?: string;
};

const StoreStatus = ({
    isOpen,
    statusText,
    openClosesAt
}: StoreStatusProps) => {
    return (
        <p
            className={cn(
                "tw:flex tw:mb-2 tw:relative",
                "tw:before:absolute tw:before:rounded-full tw:before:h-2.5 tw:before:w-2.5 tw:before:left-0 tw:before:top-[calc(50%-5px)]",
                {
                    "tw:before:bg-danger": !isOpen,
                    "tw:before:bg-success": isOpen
                }
            )}
        >
            <span className={cn("tw:ml-5 tw:block")}>{statusText}</span>
            {openClosesAt && (
                <>
                    <span
                        className={cn(
                            "tw:block tw:h-4 tw:my-auto tw:mx-2 tw:border-l tw:border-l-grey-input"
                        )}
                    />
                    <span>{openClosesAt}</span>
                </>
            )}
        </p>
    );
};

export { StoreStatus };
